import BaseModel from './BaseModel';

class Count extends BaseModel {}

Count.collection = 'Counts';

export default Count;
